import React from "react";
import { FaStar, FaStarHalfAlt, FaChrome } from "react-icons/fa";
import HeadImg from "../../../assets/Api/Header/Bg.svg";

const Header = () => {
  const handlenav = () => {
    window.location.href = process.env.REACT_APP_BASE_URL;
  };
  return (
    <div className="relative flex h-[70vh] flex-col 2xl:h-[50vh]">
      <img
        src={HeadImg}
        alt="Header Background"
        className="absolute bottom-0 left-0 w-full object-cover"
      />
      <div className="flex flex-col items-center justify-center pt-5 min-[450px]:pt-14 relative z-10">
        <div className="text-center max-w-4xl px-8 md:px-10 lg:px-10">
          <div className="inline-flex justify-center mb-4 bg-gray-100 p-1 rounded-md">
            <button className="py-2 px-4 rounded-md bg-white text-gray-800 font-semibold shadow-sm">
              Chrome
            </button>
            <div className="relative group">
              <button className="py-2 px-6 rounded-md text-gray-600 hover:bg-gray-200">
                Firefox
              </button>
              <span className="absolute whitespace-nowrap bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-600 rounded-md opacity-0 group-hover:opacity-100 transition-opacity">
                Coming Soon
              </span>
            </div>

            <div className="relative group">
              <button className="py-2 px-6 rounded-md text-gray-600 hover:bg-gray-200">
                Edge
              </button>
              <span className="absolute bottom-full whitespace-nowrap left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-600 rounded-md opacity-0 group-hover:opacity-100 transition-opacity">
                Coming Soon
              </span>
            </div>
          </div>

          <p className="text-xl text-[1.7rem] font-medium leading-[1.67] text-gray-700">
            Extension
          </p>
          <h1 className="text-3xl md:text-[42px] font-semibold text-center mt-2 !leading-[1.25]">
            <span>ExactMails for Chrome</span>
          </h1>
          <p className="sm:text-lg text-md text-gray-400 mb-5 mt-3">
            Find Verified Emails from LinkedIn with One Click
          </p>
          <div className="text-center w-full flex flex-col items-center mb-4">
            <button
              onClick={handlenav}
              className="text-white bg-background hover:bg-hover font-semibold px-3 py-4 rounded-md hover:text-white w-[250px] flex items-center justify-center space-x-2"
            >
              <FaChrome className="text-white text-lg" />
              <span>Add to Chrome - It's Free</span>
            </button>
            <div className="flex items-center space-x-1 mt-3 text-gray-600">
              <FaStar className="text-yellow-500" />
              <FaStar className="text-yellow-500" />
              <FaStar className="text-yellow-500" />
              <FaStar className="text-yellow-500" />
              <FaStarHalfAlt className="text-yellow-500" />
              <span className="text-sm ml-2 text-gray-600">
                1,000+ <span className="underline cursor-pointer">reviews</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
